import { IBeeswaxTaskIdResponseBody } from '@/Interfaces/Beeswax/TaskIdResponse.interface';
import { REPORTING_BEESWAX_LOOKER_ENDPOINT } from '@/constants/endpoints';
import axios, { AxiosError, AxiosResponse, HttpStatusCode } from 'axios';
import { wait } from '../common';

export const MAX_RETRIES = 1;

export async function getTaskId<ReqBody = any, ResBody = IBeeswaxTaskIdResponseBody>(
  body: ReqBody,
  params: {
    signal?: AbortSignal;
    bustCache?: boolean;
    retry?: boolean;
  } = {},
  url: string,
): Promise<AxiosResponse<ResBody>> {
  const { retry, signal, bustCache } = params || {};
  const res = await axios.post(url, body, {
    signal,
    headers: {
      'x-bust-cache': bustCache,
    },
  });
  if (res.status === HttpStatusCode.NoContent && (retry ?? true)) {
    await wait(200);
    return getTaskId(body, { signal, bustCache, retry: false }, url);
  }
  return res;
}

export async function fetchLookerReport<TBody = any, TReport = any, TFallback = any>({
  signal,
  body,
  maxRetries = MAX_RETRIES,
  url = REPORTING_BEESWAX_LOOKER_ENDPOINT,
}: {
  signal?: AbortSignal;
  body: TBody;
  maxRetries?: number;
  url?: string;
}): Promise<TReport | TFallback> {
  let reportResponse;
  let attemptRetry = false;
  let retryCounter = 0;

  do {
    try {
      reportResponse = await axios.post(url, body, { signal });
      attemptRetry = false;
    } catch (error) {
      if ((error as AxiosError)?.response?.status !== HttpStatusCode.NotFound) {
        throw error;
      }
      attemptRetry = true;
      retryCounter++;
    }
  } while (retryCounter <= maxRetries && attemptRetry);

  return reportResponse?.data;
}

export const fulfilledReportCaseHandler = (reportType: string) => (state: any, action: any) => {
  const requestIdVariableName = `${reportType}RequestId`;
  if (state[requestIdVariableName] === action.meta.requestId) {
    state[requestIdVariableName] = null;
    state[reportType] = action.payload?.report;
  }
};
